import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | failed | timeout
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("failed"); return; }
        attempts.current += 1;
        if (attempts.current >= 8) { setStatus("timeout"); return; }
        timer = setTimeout(poll, 2000);
      } catch {
        attempts.current += 1;
        if (attempts.current >= 8) { setStatus("timeout"); return; }
        timer = setTimeout(poll, 2000);
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page">
      <Header />
      <div className="max-w-xl mx-auto px-5 py-24 text-center">
        {status === "checking" && (
          <div data-testid="payment-checking">
            <Loader2 className="h-14 w-14 mx-auto text-[#d4af37] animate-spin mb-6" />
            <div className="font-serif text-3xl">Verifying payment…</div>
          </div>
        )}
        {status === "paid" && (
          <div data-testid="payment-paid">
            <CheckCircle2 className="h-16 w-16 mx-auto text-[#d4af37] mb-6" />
            <div className="font-serif text-4xl mb-2">Payment confirmed</div>
            <p className="text-neutral-400 mb-8">Your seat is secured. Welcome to the cohort.</p>
            <button onClick={() => nav("/student")} className="btn-imperial" data-testid="payment-go-dashboard">
              Go to dashboard
            </button>
          </div>
        )}
        {(status === "failed" || status === "timeout") && (
          <div data-testid="payment-failed">
            <XCircle className="h-16 w-16 mx-auto text-[#e6192b] mb-6" />
            <div className="font-serif text-3xl mb-2">{status === "timeout" ? "Still processing" : "Payment not completed"}</div>
            <p className="text-neutral-400 mb-8">
              {status === "timeout"
                ? "We're still confirming with Stripe. Refresh in a moment or check email."
                : "Please try again or use a manual payment method."}
            </p>
            <button onClick={() => nav("/enroll")} className="btn-outline-gold" data-testid="payment-retry">
              Back to enrollment
            </button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
